import { useTranslation } from 'react-i18next';
import styles from './checkoutLayout.module.scss';
import { BenefitItem } from './primitives';

export function AlwaysIncluded({ items }: { items: string[] }) {
  const { t } = useTranslation();

  if (items.length === 0) {
    return null;
  }

  return (
    <div className={styles.included}>
      <div className={styles.includedTitle}>{t('Always included')}</div>
      <ul className={styles.includedList}>
        {items.map((item) => (
          <BenefitItem key={item} label={t(item)} variant="compact" />
        ))}
      </ul>
    </div>
  );
}
